import { render } from "./WpeTransfer.vue?vue&type=template&id=b4576fc6"
import script from "./WpeTransfer.vue?vue&type=script&lang=js"
export * from "./WpeTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeTransfer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4576fc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4576fc6', __exports__)) {
    api.reload('b4576fc6', __exports__)
  }
  
  module.hot.accept("./WpeTransfer.vue?vue&type=template&id=b4576fc6", () => {
    api.rerender('b4576fc6', render)
  })

}


export default __exports__